module.exports = __webpack_public_path__ + "img/dianjiyun4.62b48aad.png";